<template>
    <div class="select-scroll" v-on-clickaway="close">
        <button type="button" aria-haspopup="listbox" :aria-expanded="open" class="btn-input" @click="toggle" :disabled="this.disabled">
            +{{ buttonLabel }}
        </button>

        <ul tabindex="-1" role="listbox" aria-labelledby="" v-show="open">
            <li v-for="(option, index) in options" v-html="itemLabel(index)" :key="option.name" role="option" @click="select(index)"></li>
        </ul>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        name: "SelectScroll",

        mixins: [ clickaway ],

        props: {
            'options' : {
                type: Array,
                required: true
            },
            'label' : {
                type: String
            },
            'selectedLabel' : {
                type: String
            },
            'value' : {
                required: false
            },
            'disabled' : {
                type: Boolean,
                required : false
            }
        },

        data() {
            return {
                open: false,
            }
        },

        methods: {
            toggle() {
                this.$data.open = !this.$data.open;
            },

            close() {
                this.$data.open = false;
            },

            select(id) {
                this.$emit('input', id);
                this.close();
            },

            itemLabel: function(id) {
                if(this.$props.label in this.$props.options[id]) {
                    return this.$props.options[id][this.$props.label];
                } else {
                    return '';
                }
            }
        },

        computed: {
            buttonLabel: function () {
                let selected = this.$props.value;

                if(this.$props.selectedLabel in this.$props.options[selected]) {
                    return this.$props.options[selected][this.$props.selectedLabel];
                }
                else if(this.$props.labels[0] in this.$props.options[selected]) {
                    return this.$props.options[selected][this.$props.labels[0]];
                }
                else {
                    return selected;
                }

            }
        }
    }
</script>